export default "__VITE_ASSET__CAKLePCG__"